export function mapPeriodoDiaParaTitulo(periodoDiaId) {
  if (periodoDiaId === 1) return 'Manhã'
  if (periodoDiaId === 2) return 'Tarde'
  return 'Noite'
}

export function mapPeriodoDiaParaCor(periodoDiaId) {
  if (periodoDiaId === 1) return 'primary'
  if (periodoDiaId === 2) return 'success'
  return 'error'
}

export function replaceDateTimeWithNewTime(dateTime, newTime) {
  const [date] = dateTime.split('T')

  return new Date(`${date}T${newTime}`)
}

export function passDateToDayAfter(dateTime) {
  const date = new Date(dateTime)

  date.setDate(date.getDate() + 1)

  return date
}
